import { FilterInput, ParsedFilter, QueryParams } from 'types';
// this is the list of reserved keys
const RESERVED_KEYS = ['page', 'size', 'include', 'sort', 'searchKey', 'searchValue', 'searchField'];
export function clearFilterCondition(filter: string | undefined, fieldName: string): string | undefined {
  if (!filter) return undefined;
  const parts = filter.split('&&').filter(Boolean);
  const newParts = parts.filter((condition) => !condition.startsWith(`${fieldName}:`));
  const newFilter = newParts.join('&&');
  return newFilter || '';
}
export function parseSimpleFilter(filter?: string | null): ParsedFilter[] {
  if (!filter) return [];

  return filter
    .split('&&')
    .filter(Boolean)
    .map((condition) => {
      const parts = condition.split(':');
      return {
        key: parts[0],
        raw: parts[2] ?? '', // phần sau operator
      };
    });
}
export function buildFullParams(
  input: FilterInput,
  columnEq?: string[],
  columnArr?: string[],
  fieldMappings?: Record<string, string>,
  columnDate?: string[],
) {
  const params = new URLSearchParams();

  let effectiveSearchValue = input.searchValue;
  if ('searchField' in input && input.searchField) {
    const fieldValue = input[input.searchField as keyof typeof input];
    if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
      effectiveSearchValue = String(fieldValue);
    }
  }

  Object.entries(input).forEach(([key, raw]) => {
    if (RESERVED_KEYS.includes(key) || (input.searchField && key === input.searchField)) return;
    const fieldName = fieldMappings && fieldMappings[key] ? fieldMappings[key] : key;
    // columnEq is columns will search with decorator @eq
    if (columnEq?.includes(key)) {
      params.append('filter', `${fieldName}:eq:${raw}`);
    } else if (columnArr?.includes(key) && (raw || typeof raw === 'boolean')) {
      if (typeof raw === 'boolean') {
        const formatted = [];
        if (raw) {
          formatted.push('1');
        } else {
          formatted.push('0');
        }
        params.append('filter', `${fieldName}:in:[${formatted}]`);
      } else {
        if (raw.toString().includes('[') && raw.toString().includes(']')) {
          params.append('filter', `${fieldName}:in:${raw}`);
        } else {
          const newRaw = (raw as string)?.split(',');
          const formatted = newRaw.map((item) => `'${item}'`).join(', ');
          params.append('filter', `${fieldName}:in:[${formatted}]`);
        }
      }
      console.log('params', params.get('filter'));
    } else if (columnDate?.includes(key)) {
      if (!raw) return;
      const [gte, lts] = ((raw as string) || '').split(',').map((d) => d.trim());
      params.append('filter', `${fieldName}:gte:${gte}&&${fieldName}:lte:${lts}`);
    } else if (typeof raw === 'string' || typeof raw === 'number') {
      if (raw === '' && !raw) return;
      if (key?.includes('id')) params.append('filter', `${fieldName}:eq:${raw}`);
      else params.append('filter', `${fieldName}:like:${raw}`);
    } else if (typeof raw === 'object' && raw.rule) {
      const { rule, value } = raw;
      if (Array.isArray(value) && value.length > 0) {
        params.append('filter', `${fieldName}:in:${value}`);
      } else if (rule === 'isnull' || rule === 'isnotnull') {
        params.append('filter', `${fieldName}:${rule}`);
      } else if (value !== undefined && value !== null && value !== '') {
        params.append('filter', `${fieldName}:${rule}:${value}`);
      }
    }
  });

  // Reserved params
  if ('page' in input) params.set('page', String(input.page));
  if ('size' in input) params.set('size', String(input.size));
  if ('include' in input) params.set('include', String(input.include));

  if ('searchKey' in input && effectiveSearchValue) {
    params.set('searchKey', String(input.searchKey));
    params.set('searchValue', effectiveSearchValue.toString());
  }
  const queryParams: QueryParams = {};
  let hasFilter = false;
  for (const [key, value] of params.entries()) {
    if (key === 'filter') {
      hasFilter = true;
      queryParams.filter = queryParams.filter ? `${queryParams.filter}&&${value}` : value;
    } else {
      queryParams[key] = value;
    }
  }
  if (!hasFilter) {
    queryParams.filter = '';
  }
  return queryParams;
}

export const fieldMappings = {
  code: 'baseUser.code',
  name: 'baseUser.name',
  gmail: 'baseUser.email',
  phoneNumber: 'baseUser.phoneNumber',
};
